Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Video19214044",
  {"root":"Video19214044--root","playerContainer":"Video19214044--playerContainer","responsiveMode":"Video19214044--responsiveMode","cover":"Video19214044--cover","transparentOverlay":"Video19214044--transparentOverlay","overlay":"Video19214044--overlay","title":"Video19214044--title","poster":"Video19214044--poster"},
  "",
  1,
  /*! ../node_modules/wix-ui-core/dist/src/components/video/Video.st.css */ 126
);

